import { render } from "./ProsesSubKomponen.vue?vue&type=template&id=5c55ed09"
import script from "./ProsesSubKomponen.vue?vue&type=script&lang=js"
export * from "./ProsesSubKomponen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__